import { render, staticRenderFns } from "./ButtonSetThemeHeader.vue?vue&type=template&id=b4de47fa&scoped=true"
import script from "./ButtonSetThemeHeader.vue?vue&type=script&lang=js"
export * from "./ButtonSetThemeHeader.vue?vue&type=script&lang=js"
import style0 from "./ButtonSetThemeHeader.vue?vue&type=style&index=0&id=b4de47fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4de47fa",
  null
  
)

export default component.exports